import FeedbackTyp from './FeedbackTyp';
export default FeedbackTyp;